import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Chip, FormControl, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { handleClearFilter, handleJobFilters } from '../../store/reducer/commonSlice';
import './selectField.css';

const SelectField = ({ label, items, value, multiple }) => {
  const dispatch = useDispatch();

  return (
    <div className='select'>
      <FormControl key={label} size='small' fullWidth sx={{ width: multiple ? '200px' : 'inherit' }}>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        {multiple ? (
          <Select
            size='small'
            key={label}
            value={value}
            multiple={multiple}
            onChange={(e) => {
              dispatch(handleJobFilters({
                key: label,
                value: [...e.target.value]
              }));
            }}
            MenuProps={{
              className: 'menu-content',
              PopoverClasses: 'menu-popover'
            }}
            renderValue={(selected) => (
              <Box className='chip-wrapper'>
                {selected.map((val) => (
                  <Chip
                    key={val}
                    label={val}
                    deleteIcon={
                      <ClearIcon
                        color='#000'
                        onMouseDown={(event) => event.stopPropagation()}
                      />
                    }
                    onDelete={(e) => {
                      e.preventDefault();
                      dispatch(handleClearFilter({ key: label, value: value.filter((i) => i !== val) }));
                    }} />
                ))}
              </Box>
            )}
          >
            {
              items?.map((i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))
            }
          </Select>
        ) : (
          <Select
            size='small'
            key={label}
            value={value}
            onChange={(e) => {
              dispatch(handleJobFilters({
                key: label,
                value: e.target.value
              }))
            }}
            MenuProps={{
              className: 'menu-content',
              PopoverClasses: 'menu-popover'
            }}
            endAdornment={
              value && (
                <InputAdornment sx={{ marginRight: '8px' }} position='end'>
                  <Button className='clear-filter-btn' type='button' onClick={() => dispatch(handleClearFilter(label))}>
                    <ClearIcon color='#000' />
                  </Button>
                </InputAdornment>
              )
            }
          >
            {
              items?.map((i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))
            }
          </Select>
        )}
      </FormControl>
    </div>
  )
}

export default SelectField;
